import type { MouseEvent } from "react"

const ROW_CONTROL_SELECTOR = "button, input, a, .MuiCheckbox-root, [role='menuitem']"

export function isOrderRowControlClick({ target, currentTarget }: MouseEvent<HTMLElement>): boolean {
    if (!(target instanceof Element)) return false
    if (!currentTarget.contains(target)) return true
    const control = target.closest(ROW_CONTROL_SELECTOR)
    return control !== null && currentTarget.contains(control)
}
